import * as React from 'react';
import { number, oneOfType, shape, string } from 'prop-types';
import { cx } from '@emotion/css';

import ICON_LIST from './icons-list';
import { stySvgIcon } from './style';

const SvgIcon = ({ name, className, ...props }) => {
  const IconComponent = React.useMemo(() => ICON_LIST[name], [name]);

  return IconComponent && <IconComponent className={cx(stySvgIcon(props), className)} {...props} />;
};

SvgIcon.propTypes = {
  name: string.isRequired,
  color: string,
  className: string,
  height: oneOfType([number, string]),
  width: oneOfType([number, string]),
  style: shape({}),
};

SvgIcon.defaultProps = {
  color: '#000',
  className: '',
  height: 24,
  width: 24,
  style: {},
};

const Memo = React.memo(SvgIcon);
export default Memo;

// npx @svgr/cli --ref --no-dimensions --out-dir <output-directory> -- <input-file-directory>
// npx @svgr/cli --ref --no-dimensions --out-dir src/components/SvgIcon/icons -- src/assets/icons
